__turbopack_context__.v({
  "closer": "grid-module-scss-module__leSunq__closer",
  "grid": "grid-module-scss-module__leSunq__grid",
  "height100": "grid-module-scss-module__leSunq__height100",
  "reverseMobile": "grid-module-scss-module__leSunq__reverseMobile",
  "sideMargin": "grid-module-scss-module__leSunq__sideMargin",
});
